import { useCallback, useEffect, useState } from 'react';

import { useConfig } from '@occc/config';
import { CreateCsrotpSessionMutation, VerifyCsrotpSessionMutation } from '@occc/graphql';
import { useToggle } from '@occc/utils';

export const useCSR = (isCSRLoginStarted: boolean, onCSRLoginCancelled: () => void) => {
  const {
    config: {
      csrLogin: { authMethod },
    },
  } = useConfig();
  const isOTPFlow = authMethod === 'OTP';
  const [isSendOTPCodeModalOpen, toggleSendOTPCodeModal] = useToggle();
  const [isEnterOTPCodeModalOpen, toggleEnterOTPCodeModal] = useToggle();
  const [isOpenExperienceAppAsMemberModalOpen, toggleOpenExperienceAppAsMemberModal] = useToggle();
  const [session, setSession] = useState<undefined | string>(undefined);
  const [smsURL, setSmsURL] = useState<undefined | string>(undefined);

  const onSendOTPCodeCompleted = useCallback(
    (value: CreateCsrotpSessionMutation) => {
      setSession(value.createCSROTPSession.session);
      toggleSendOTPCodeModal();
      toggleEnterOTPCodeModal();
    },
    [toggleEnterOTPCodeModal, toggleSendOTPCodeModal],
  );
  const onEnterOTPCodeCompleted = useCallback(
    (value: VerifyCsrotpSessionMutation) => {
      setSmsURL(value.verifyCSROTPSession.url);
      toggleEnterOTPCodeModal();
      toggleOpenExperienceAppAsMemberModal();
    },
    [toggleEnterOTPCodeModal, toggleOpenExperienceAppAsMemberModal],
  );

  const onSendOTPCodeModalHide = useCallback(() => {
    onCSRLoginCancelled();
    toggleSendOTPCodeModal();
  }, [onCSRLoginCancelled, toggleSendOTPCodeModal]);
  const onEnterOTPCodeModalHide = useCallback(() => {
    onCSRLoginCancelled();
    toggleEnterOTPCodeModal();
  }, [onCSRLoginCancelled, toggleEnterOTPCodeModal]);
  const onOpenExperienceModalHide = useCallback(() => {
    onCSRLoginCancelled();
    toggleOpenExperienceAppAsMemberModal();
  }, [onCSRLoginCancelled, toggleOpenExperienceAppAsMemberModal]);
  useEffect(() => {
    if (!isCSRLoginStarted) {
      return;
    }

    if (isOTPFlow) {
      toggleSendOTPCodeModal();
    } else {
      toggleOpenExperienceAppAsMemberModal();
    }
  }, [isCSRLoginStarted, isOTPFlow, toggleOpenExperienceAppAsMemberModal, toggleSendOTPCodeModal]);

  return {
    isSendOTPCodeModalOpen,
    isEnterOTPCodeModalOpen,
    isOpenExperienceAppAsMemberModalOpen,
    onSendOTPCodeModalHide,
    onEnterOTPCodeModalHide,
    onOpenExperienceModalHide,
    onSendOTPCodeCompleted,
    onEnterOTPCodeCompleted,
    session,
    smsURL: smsURL,
    isOTPFlow,
  };
};
